<template>
   <Progress :active="active" />

   <div>
      <Button icon="pi pi-times" @click="this.abrirDialog()" class="p-button-incluir" />

      <Dialog v-model:visible="atvDialog" :style="{ width: '350px' }" header="Confirmação!" :modal="true" class="p-fluid" :closable="false" required>
         <Progress :active="active" />

         <div class="flex">
            <span
               ><h4>
                  Deseja desconsiderar registro na data:
                  {{ this.atividadePorId.dataAtividade }} Hora:
                  {{ this.atividadePorId.hora }}
               </h4></span
            >
            <!--  -->
         </div>
         <div class="field" v-if="this.configuracao.observacaoSolicitacaoObrigatorio">
            <label for="observacao">Observação</label>

            <Textarea v-model="observacao" rows="5" cols="30" />
         </div>
         <div class="w-full flex align-items-center justify-content-around">
            <div class="w-full flex p-2">
               <Button label="Não" icon="pi pi-times" class="p-button-danger btn-confirm" @click="atvDialog = false" />
            </div>
            <div class="w-full flex p-2">
               <Button label="Sim" icon="pi pi-check" class="p-button btn-confirm" @click="desconsiderarAtividade()" />
            </div>
         </div>
      </Dialog>

      <Toast />
   </div>
</template>
<script src="./desconsiderar-atividade.js"></script>
